export const getMetaDataList = ({ metaDataReducer: { meta_data = [] } = {} }) =>
  meta_data;

export const getMetaDataFilter = ({ metaDataReducer: { filter = {} } = {} }) =>
  filter;

export const getMetaDataCount = ({ metaDataReducer: { count = 0 } = {} }) =>
  count;
